import { lazy } from 'react';

const DataIntegrationChooseIdentifierModal = lazy(() =>
  import('./pages/UploadDetails/components/ChooseIdentifierModal'),
);
const CustomDataSetModal = lazy(() =>
  import('./containers/CustomDataSetModal'),
);
const ConfirmDeleteCustomDataSet = lazy(() =>
  import('./containers/ConfirmDeleteCustomDataSet'),
);

export default {
  CONFIRM_DELETE_CUSTOM_DATA_SET: ConfirmDeleteCustomDataSet,
  CUSTOM_DATA_SET_MODAL: CustomDataSetModal,
  DATA_INTEGRATION_IDENTIFIER: DataIntegrationChooseIdentifierModal,
};
